<template>
  <div>
    <div class="ECMonitor-title">
      <div>{{ $t("alarms.instance.instance") }}</div>
      <div>
        <Button
          type="primary"
          @click="addOrUpdateHandle"
          v-hasPermission="[
            'monitor:elasticComputeCloudMonitor:add_alert_rule'
          ]"
          >{{ $t("alarms.instance.addInstanceAlarm") }}</Button
        >
        <Button
          v-if="currentTab === 'tabAlertRule'"
          type="warning"
          @click="exportAlertRuleList"
        >{{ $t("common.exportInstanceAlarmRule") }}</Button
        >
        <add-or-update-elastic-compute-cloud-warning
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
        ></add-or-update-elastic-compute-cloud-warning>
      </div>
    </div>
    <template>
      <Tabs size="small" v-model="currentTab" :animated="false">
        <TabPane :label="$t('alarms.instance.instanceList')" name="tabInstance">
          <table-elastic-compute-cloud
            @changeCurrentTab="changeCurrentTab"
          ></table-elastic-compute-cloud>
        </TabPane>
        <TabPane :label="$t('alarms.common.alertRule')" name="tabAlertRule">
          <div>
            <elastic-compute-cloud-monitor-alert-rule-search ref="ruleSearch"></elastic-compute-cloud-monitor-alert-rule-search>
          </div>
          <table-elastic-compute-cloud-warning></table-elastic-compute-cloud-warning>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import TableElasticComputeCloud from "../ec2/TableElasticComputeCloud";
import AddOrUpdateElasticComputeCloudWarning from "../ec2/AddOrUpdateElasticComputeCloudWarning";
import LogWarningSearch from "../logs/log/LogWarningSearch";
import TableLogWarning from "../logs/log/TableLogWarning";
import TableElasticComputeCloudWarning from "./TableElasticComputeCloudWarning";
import ElasticComputeCloudMonitorAlertRuleSearch from "./ElasticComputeCloudMonitorAlertRuleSearch";
import {getCookie} from "../../../utils/cookieUtil";

const tableElasticComputeCloudWarning = TableElasticComputeCloudWarning;
export default {
  name: "ElasticComputeCloudMonitor",
  components: {
    TableElasticComputeCloudWarning,
    ElasticComputeCloudMonitorAlertRuleSearch,
    LogWarningSearch,
    TableLogWarning,
    TableElasticComputeCloud,
    AddOrUpdateElasticComputeCloudWarning
  },
  data() {
    return {
      currentTab: "",
      addOrUpdateVisible: false
    };
  },
  methods: {
    // 添加报警规则
    /**********************************************************************************/
    addOrUpdateHandle: function() {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init();
      });
    },
    changeCurrentTab: function(row, monitorIndex) {
      this.currentTab = "tabAlertRule";
      eventBus.$emit("instanceId", row.instanceId);
      eventBus.$emit("monitorIndex", monitorIndex);
      eventBus.$emit("typeId", 1);
      // eventBus.$emit('stateId', 0);
      tableElasticComputeCloudWarning.methods.showAll();
    },
    /***********************导出*****************************/
    exportAlertRuleList: function () {
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      })
      // 下载Excel 文件
      this.$api.alertRule.exportResourceAlertRule({
        companyId: !this.$refs.ruleSearch.companyId ? getCookie(global.companyId) : this.$refs.ruleSearch.companyId,
        monitorModule: 0,
        accountId: this.$refs.ruleSearch.accountId,
        stateId: this.$refs.ruleSearch.stateId,
        typeId: this.$refs.ruleSearch.typeId,
        delayTypeId: this.$refs.ruleSearch.delayTypeId
      })
        .then(res => {
          let fileName = 'resourceAlertRule.xls'
          let blob = new Blob([res.data], {type: 'application/x-xls'})
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          }else{
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.$Message.success(this.$t('common.exportSuccess'));
        })
        .finally(() => {
          this.$Message.destroy();
        })
    }
  }
};
</script>

<style scoped>
.ECMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.ECMonitor-title > div:nth-child(1) {
  float: left;
}
.ECMonitor-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/ec2/ElasticComputeCloudMonitor.vue